<template>
    <client-page>

        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Fleece & Sherpa Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Fleece & Sherpa Line" file="fleece">
                Sherpa with short/long pile, Polar fleece, Mink Fleece, Terry Fleece,
                Velour, Brushed Knit, etc. We have a lot of experience with synthetic
                blend sherpa and fleece fabrics. Also have special strengths of
                price and quality.
            </sub-product>
        </sub-section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped>
</style>
